<script>
  import { onMount, onDestroy } from "svelte";
  import FrictionStep from "./FrictionStep.svelte";
  import Belay from "./Belay.svelte";
  import Toolbar from "./Toolbar.svelte";
  import * as timeago from "timeago.js";
  import Delete16 from "carbon-icons-svelte/lib/Delete16";
  import Add24 from "carbon-icons-svelte/lib/Add24";
  import Switch from "./Switch.svelte";
  import Lock from "./icons/Lock.svelte";
  import ArrowCurveUpLeft from "./icons/ArrowCurveUpLeft.svelte";

  import Smiley from "./Smiley.svelte";
  import { createEventDispatcher } from "svelte";
  import { tick } from "svelte";
  import moment from "moment";
  import { auth, googleProvider } from "../firebase";
  import { authState } from "rxfire/auth";
  import "lightgallery.js";
  
  import  "lg-zoom.js";

  let user;

  const unsubscribe = authState(auth).subscribe((u) => (user = u));

  const dispatch = createEventDispatcher();

  function dispatchMessage(value) {
    dispatch("message", {
      message: value,
    });
  }

  $: displayLastUpdate = updated ? convertDate(updated) : created;

  function handleSave() {
    updated = Date();
    dispatchMessage("update");
  }

  let updating = false;
  let mounted = false;
  let showHelp = false;

  let a = 5;

  export let title = "Friction Map";
  export let description = "About this map";
  export let created = "Unknown";
  export let updated;
  export let owned = false;
  export let shared;
  export let data;

  let belayProps = {
    pointRadius: 2,
    strokeWidth: 3,
    pointColor: "rgba(0,0,0,1)",
    strokeColor: "rgba(0,178,255, 1)",
  };

  onMount(() => {
    mounted = true;
    updating = true;

    lightGallery(document.getElementById("journeymap"), {
      selector: ".image",
      zoom: true,
    });
  });

  onDestroy(() => {
    updating = false;
  });

  $: averageSatisfaction = getAverage(data);
  $: totalFrictionPoints = getTotalPoints(data);
  $: frictionScore = getFrictionScore(data);

  function convertDate(timestamp) {
    return moment(timestamp).format("YYYY-MM-DD h:mm a");
  }

  function getAverage(array) {
    let sum = 0;
    data.forEach((item) => (sum += item.cs));
    return Math.floor(sum / data.length);
  }

  function getTotalPoints(array) {
    let sum = 0;
    data.forEach((item) => (sum += item.fp));
    return sum;
  }

  function getFrictionScore(array) {
    let sum = 0;
    data.forEach((item) => (sum += item.fs));
    return sum;
  }

  async function addStep() {
    var obj = {
      id: data.length + 1,
      title: "Step " + (data.length + 1),
      description: "",
      fpText: "",
      thumb: "",
      thumbName: "",
    };
    data = [...data, obj];

    await tick();

    var vw = window.innerWidth;
    var el = document.getElementById("mapContent");
    el.scrollTo({ left: el.scrollWidth - vw, top: 0, behavior: "smooth" });
  }

  function deleteStep(key) {
    data = data.filter(function (obj) {
      return obj.id !== key;
    });
    let index = 1;
    data.forEach((item) => (item.id = index | index++));
  }

  function updateIndex(element, index, array) {}

  function handleMessage(event) {
    console.log("reset from update");
    // resetZooming();
  }

  function resetZooming() {
    // zooming.listen("[data-zoomable]");
  }

  function toggleHelp() {
    showHelp = !showHelp;
  }

  function toggleShared() {
    shared = shared ? false : true;
  }
</script>

<svelte:head>
  <link
    type="text/css"
    rel="stylesheet"
    href="lightgallery/css/lightgallery.css"
  />
</svelte:head>


<div class="mb-4 md:flex md:items-center">
  <div class="">
    <h1
      class="maptitle text-3xl font-bold editabletext"
      contenteditable="true"
      bind:innerHTML={title}
    >
      {title}
    </h1>

    <p
      class="editabletext my-2"
      class:emptytext={description == ""}
      contenteditable="true"
      bind:innerHTML={description}
    >
      {description}
    </p>
  </div>
 
</div>

<div class="mapGrid">
  <div id="mapContent" class="mapContent">
    <div class="wrapper" id="frictionMapper">
      {#if mounted}
        {#each data as item}
          {#if item.id > 1}
            <Belay
              parent="frictionMapper"
              bind:shouldUpdate={updating}
              el1="smiley-button-{item.id - 1}"
              el2="smiley-button-{item.id}"
              {...belayProps}
            />
          {/if}
        {/each}
      {/if}

     

      <div class="grid" id="journeymap">
        {#each data as item}
          <FrictionStep
            totalSteps={data.length}
            key={item.id}
            bind:title={item.title}
            bind:description={item.description}
            bind:cs={item.cs}
            bind:fp={item.fp}
            bind:fs={item.fs}
            bind:thumb={item.thumb}
            bind:thumbName={item.thumbName}
            bind:fpText={item.fpText}
            on:message={handleMessage}
            bind:totalFrictionPoints
            bind:averageSatisfaction
          />
          {#if user}
            <Toolbar>
              <Delete16
                on:click={() => {
                  deleteStep(item.id);
                }}
              />
            </Toolbar>
          {:else}
            <div class="border-r" />
          {/if}
        {/each}
        {#if user}
          <!-- AFTER THE MAP -->
          <div style="grid-row:span 2;" class="border-t-4 border-black pt-2">
            <div
              id="addStep"
              class="add-step no-print hover:border-black hover:cursor-pointer"
              on:click={addStep}
            >
              <div style="align-self:center;justify-self:center">
                <Add24 />
              </div>
            </div>
          </div>
          <div class=""></div>
          <div style="" class="">
            
            <p class="text-xs text-italic text-gray-500 self-end px-4"><em>Adjust the sliders to show customer satisfaction at each point in the flow.</em></p>
        
          </div>
          <div style="" class="">
            
            <p class="text-xs text-italic text-gray-500 self-end px-4"><em>Add text descriptions to explain why the customer satisfaction is low or high. </em></p>
          </div>
          <div class=""></div>          
          <div style="grid-row:span 2;" class="">
            
            <p class="text-xs text-italic text-gray-500 self-end px-4"><em>Typing a friction keyword will highlight and calculate KLM values: taps, clicks, presses, swipes, hovers, types, reads, scrolls, decides, page loads, moves mouse, modal opens, modal closes, menu opens, menu closes, popup opens, popup closes. You can also add friction time using a number followed immediately by [fp] or [s] (1fp or 2s) </em></p>
          </div>
        {/if}
      </div>
    </div>
  </div>
</div>

<span class="text-xs">Last updated: <span class="text-mapblue" >{displayLastUpdate}</span></span>

<div
class=" fixed right-8 top-20  ml-auto flex items-center space-x-4 rounded-lg shadow-md bg-white p-4"
>

{#if user}
  <!-- <span
    ><button
      class="border rounded-lg px-4 py-2 bg-white text-sm text-white bg-mapblue hover:border-black"
      on:click={handleSave}>Save Map</button
    ></span
  > -->
{/if}
{#if owned}
<span on:click={toggleShared} class:opacity-25={shared}>
  <Lock bind:locked={shared} />
</span>
{/if}          
</div>



<style>
  .editabletext:hover {
    @apply bg-gray-100;
  }
  .emptytext {
    @apply rounded bg-gray-100;
  }

  .grid {
    height: 100%;
    display: grid;
    grid-gap: 0px;
    grid-template-rows: repeat(8, auto);
    grid-auto-columns: 250px;
    grid-auto-flow: column;
    background: white;
  }

  .wrapper {
    position: relative;
    padding: 0;
    margin: 0;
  }

  .key,
  .key-lowLabel {
    text-transform: uppercase;
    letter-spacing: 0.2em;
    color: rgba(0, 0, 0, 0.8);
    font-size: 0.5em;
    position: absolute;
    bottom: 10px;
    left: 10px;
  }
  .key-highLabel {
    top: 10px;
  }

  .add-step {
    @apply rounded-full shadow p-2 mx-4 border inline-block;
  }

  @media only screen and (max-width: 600px) {
    .mapHeader {
      background: rgba(0, 178, 255, 1);
      color: #fff;
      grid-area: header;
      display: grid;
      grid-template-areas: "title closebutton";
      grid-gap: 10px;
      padding: 10px;
      grid-template-columns: auto 50px;
      border-bottom: 6px solid rgba(0, 0, 0, 1);
    }

    .mapGrid {
      width: 100vw;
      height: 100vh;
    }

    .grid {
      grid-auto-columns: 50vw;
    }
    .average {
      display: none;
    }
  }
</style>
